import { format } from 'date-fns';
import { stateAndTerritoryCodes } from './constants';

// Check if string contains consecutive
export const checkConsecutive = (chars) => {
  for (let i = 0; i < chars.length - 1; i++) {
    if (chars[i] === chars[i + 1]) return true;
  }
  return false;
};



// PASSWORD VALIDATION
export const passwordValidation = (password, options, length) => {
  const isValid = [];

  const _alpha = /[A-Za-z]/.test(password);
  const _numeric = /[0-9]/.test(password);
  const _caps = /[A-Z]/.test(password);
  // eslint-disable-next-line no-useless-escape
  const _symbols = /[!@#$&()\-`.+,/\"]/.test(password);
  const _consecutive = !checkConsecutive(password);
  const _length = password.length;

  if (options.alpha) isValid.push(_alpha);
  if (options.numeric) isValid.push(_numeric);
  if (options.caps) isValid.push(_caps);
  if (options.symbols) isValid.push(_symbols);
  if (options.consecutive) isValid.push(_consecutive);
  if (length) isValid.push(_length >= length);

  for (let i = 0; i < isValid.length; i++) {
    if (!isValid[i]) return false;
  }

  return true;
};



// CLEAN DATE FORMAT
export const cleanDateFormat = (cdf, formatStr = 'MM/dd/yyyy') => {
  const isDate = (str) => {
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) {
      return true;
    }
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}./.test(str)) {
      return true;
    }
    if (/([0]?[1-9]|[1][0-2])[-|/]([0]?[1-9]|[1|2][0-9]|[3][0|1])[-|/]\d{4}/.test(str)) {
      return true;
    }
    return false;
  };

  let formatted = cdf;
  if (isDate(formatted)) {
    formatted = format(cdf, formatStr);
  }
  return formatted;
};



// GENERATE USER PRE-SIGN STATUS
export const generateUserPreSignStatus = (obj) => {
  let filter_status = 'Pre-Sign (Created)';
  if (obj.meter_applicant) {
    filter_status = 'Pre-Sign (Applicant)';
  }
  if (obj.meter_property) {
    filter_status = 'Pre-Sign (Home Details)';
  }
  if (obj.meter_owners) {
    filter_status = 'Pre-Sign (Homeowners)';
  }
  if (obj.meter_documents) {
    filter_status = 'Pre-Sign (Documents)';
  }
  if (obj.meter_signatures_sent) {
    filter_status = 'Pre-Sign (Signatures)';
  }
  return filter_status;
};


// CONVERT HEXCODES - '#FFFFFF' to (255, 255, 255,)
export const hexToRGB = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
};



// Uses regex to verify that the provided value does not contain more than X decimal places
// (for currency or sometimes percentage inputs)
export const checkDecimalPlaces = (value, numOfDecimalPlaces = 2) => {
  const regexString = `^(\\d*\\.{0,1}\\d{0,${numOfDecimalPlaces}}$)`;
  const regex = new RegExp(regexString);
  return regex.test(value);
};


// Render a full address string via provided address object with separate properties
export const renderFullAddress = (addressObj) => {
  let fullAddress = '';
  if (addressObj.address_1) fullAddress += `${addressObj.address_1}`;
  if (addressObj.address_2) fullAddress += `${addressObj.address_1 && ', '}${addressObj.address_2}`;
  if (addressObj.city) fullAddress += `${addressObj.address_1 || addressObj.address_2 ? ', ' : ' '}${addressObj.city}`;
  if (addressObj.state) {
    const foundState = stateAndTerritoryCodes.find((code) => code.value === addressObj.state);
    if (foundState) fullAddress += `${addressObj.city ? ', ' : ' '}${foundState.label}`;
  }
  if (addressObj.zip) fullAddress += ` ${addressObj.zip}`;
  return fullAddress;
};


// local version of pluralize
export const pluralize = (word, count) => (count === 1 ? word : `${word}s`);

// local version of sanitizeCSV Cell
export const sanitizeCSVCell = (dataCell) => {
  // Catch any null, undefined, etc. cases and return them as is
  if (Boolean(dataCell) === false) return dataCell;

  // These characters tell Excel that a particular cell is a function //
  const invalidCharacters = ['=', '+', '-', '@', '\n', '\t'];
  const invalidNewlines = ['n', 't'];

  const firstCharacter = dataCell[0];

  // EXCEPTION -- Dash only & numbers are valid //
  if (firstCharacter === '-') {
    const isDashOnly = dataCell === '-';
    const cleanData = dataCell.replace(/[$,]/g, '');
    const isValidNumber = !isNaN(cleanData);

    if (isValidNumber || isDashOnly) {
      return dataCell;
    }
  }

  // END EXCEPTIONS -- other cells that start with invalid characters need sanitized //
  if (invalidCharacters.includes(firstCharacter)) {
    const sanitizedCell = `'${dataCell}`;
    return sanitizedCell;
  }

  // Check the first & second char combinations for text newline characters
  if (firstCharacter === '\\') {
    const secondCharacter = dataCell[1];
    if (invalidNewlines.includes(secondCharacter)) {
      const sanitizedCell = `'${dataCell}`;
      return sanitizedCell;
    }
  }
  return dataCell;
};